<template>
   <iframe id="myIframe" src="/Service/lhmj/ruralPlaningResearch2" style="width:100%;height:1100px"  frameborder="0" ></iframe>
</template>

<script>
/* eslint-disable */
  export default {
    name: 'wjdc',
    created(){
      document.documentElement.scrollTop  = 0
    }
  }
</script>
<style scoped>
#myIframe{
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// index.vue?18875802